module.exports = __webpack_public_path__ + "media/about/proSupply-d789c8ac.jpg";